import { render, staticRenderFns } from "./TopicGroup.vue?vue&type=template&id=06d68059&scoped=true&"
import script from "./TopicGroup.vue?vue&type=script&lang=js&"
export * from "./TopicGroup.vue?vue&type=script&lang=js&"
import style0 from "./TopicGroup.vue?vue&type=style&index=0&id=06d68059&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d68059",
  null
  
)

export default component.exports